// Speisekarte
const dishes = [
  {
    title: "Suppen",
    entries: [
      { no: "1.", title: "Tomatencremesuppe", price: 5.8 },
      { no: "3.", title: "Bohnensuppe", price: 5.8 },
      { no: "107.", title: "Hühnersuppe", price: 5.8 },
      { no: "108.", title: "Gulaschsuppe", price: 5.8 }
    ]
  },
  {
    title: "Warme Vorspeisen",
    entries: [
      {
        no: "13.",
        title: "Saganaki",
        description: "Käse paniert",
        price: 7.9
      },
      { no: "13.b", title: "Knoblauchbrot", price: 4.8 },
      { no: "14.", title: "Gebackener Käse", price: 8.0 },
      {
        no: "14.b",
        title: "Pita Brot",
        description: "mit Knoblauch (Fladenbrot)",
        price: 3.8
      },
      {
        no: "9.",
        title: "Tiropitakia",
        price: 8.5,
        description: "5 Stück, Blätterteig gefüllt mit Fetakäse"
      },
      {
        no: "9.b",
        title: "Piperies Florinis",
        price: 9.0,
        description:
          "Rote Paprika mit Käse, Knoblauch und Petersilie gefüllt"
      },
      {
        no: "20.",
        title: "Weinblätter",
        description: "4 Stück, gefüllt mit Reis und Hackfleisch",
        price: 7.9
      },
      {
        no: "23.",
        title: "Stifado",
        price: 6.5,
        description: "Kleine Zwiebeln mit pikanter Tomatensauce"
      },
      { no: "25.", title: "Auberginen", price: 6.5 },
      { no: "26.", title: "Dicke Bohnen", price: 6.5 },
      { no: "27.", title: "Okra Gemüse", price: 6.5, description: "(Okraschoten)" },
      {
        no: "28.",
        title: "Gebackener Käse",
        description: "mit Knoblauch und Peperoni",
        price: 9.5
      },
      {
        no: "109.",
        title: "Gebackener Käse",
        price: 9.5,
        description: "mit Tomaten und Zwiebeln"
      },
      {
        no: "110.",
        title: "Weinblätter",
        description: "Gefüllt mit Reis",
        price: 6.3
      },
      {
        no: "111.",
        title: "Auberginen",
        description: "Mit Hackfleisch und Käse",
        price: 11.5
      },
      {
        no: "112.",
        title: "Folienkartoffeln",
        description: "mit Zaziki",
        price: 6.9
      },
      { no: "114.", title: "Pommes frites", price: 3.9 },
      { no: "115.", title: "Reis", price: 3.5 },
      { no: "116.", title: "Kroketten", price: 4.9 },
      {
        no: "121.",
        title: "Kritharaki",
        description: "(griechische Nudeln)",
        price: 4.5
      }
    ]
  },
  {
    title: "Kalte Vorspeisen",
    entries: [
      { no: "5.", title: "Zaziki", price: 4.7 },
      {
        no: "6.",
        title: "Taramasalat",
        description: "Kaviarcreme",
        price: 5.1
      },
      {
        no: "8.",
        title: "Kalamarissalat",
        description: "Tintenfisch",
        price: 9.0
      },
      {
        no: "10.",
        title: "Kalte Platte",
        price: 14.9,
        description:
          "Gemischte Vorspeisen. Kalamaris, Zaziki, Bohnensalat, Krautsalat, Kopanisti, Taramasalat, gefülltes Weinblatt mit Zwiebeln, Tomaten und Gurken"
      },
      {
        no: "12.",
        title: "Käse",
        description: "mit kleinem Bauernsalat",
        price: 7.9
      },
      { no: "15.", title: "Käse", price: 7.5 },
      { no: "18.", title: "Krautsalat", price: 7.9 },
      { no: "19.", title: "Weißer Bohnensalat", price: 4.9 },
      {
        no: "22.",
        title: "Piperies Tursi",
        description: "eingelegte Peperoni",
        price: 5.9
      },
      {
        no: "118.",
        title: "Tirosalata",
        description: "scharfe Käsecreme",
        price: 6.5
      },
      { no: "122.", title: "Gurkensalat", price: 4.9 }
    ]
  },

  {
    title: "Salate",
    entries: [
      {
        no: "16.",
        title: "Bauernsalat",
        price: 10.5,
        description:
          "Kraut, Tomaten, Gurken, Oliven, Peperoni, Zwiebeln und Fetakäse mit Öl und Essig"
      },
      {
        no: "17.",
        title: "Ceasaer Salat",
        price: 13.5,
        description:
          "Tomaten, Gurken, Kopf- und Ruccolasalat mit Mais und Hähnchenbrust, Öl und Essig"
      },
      {
        no: "120.",
        title: "Thunfischsalat",
        price: 12.5,
        description:
          "mit Kopfsalat, Tomaten, Gurken, Peperoni, Oliven, Zwiebeln und hausgemachte Sauce"
      }
    ]
  },

  {
    title: "Für unsere kleinen Gäste",
    entries: [
      {
        no: "124.",
        title: "Giros",
        description: "mit Reis und Krautsalat",
        price: 8.9
      },
      {
        no: "125.",
        title: "Souflaki",
        description: "mit Reis und Krautsalat",
        price: 8.9
      },
      {
        no: "126.",
        title: "Beefsteaks",
        description: "2 Stück mit Reis und Krautsalat",
        price: 8.9
      },
      {
        no: "127.",
        title: "Kleine Schnitzel",
        description: "2 Stück mit Reis und Krautsalat",
        price: 8.9
      },
      {
        no: "128.",
        title: "Spaghetti",
        description: "mit Tomatensauce",
        price: 7.5
      },
      {
        no: "129.",
        title: "Spaghetti",
        description: "mit Hackfleischsauce",
        price: 8.4
      },
      {
        no: "130.",
        title: "Kleines Hawaiisteak",
        price: 12.5,
        description:
          "1 Stück mit Ananas und Käse überbacken, dazu Reis und kleinem Bauernsalat"
      }
    ],
    footer: "Alle Gerichte wahlweise mit Pommes frites oder Reis"
  },
  {
    title: "Gerichte vom Grill",
    entries: [
      {
        no: "29.",
        title: "Giros",
        description: "mit Reis und kleinem Krautsalat",
        price: 14.3
      },
      {
        no: "131.",
        title: "Giros",
        description: "mit Kalamaris, Reis und Krautsalat",
        price: 17.5
      },
      {
        no: "31.",
        title: "Souflaki, 2 Spieße",
        description: "mit Reis und kleinem Krautsalat",
        price: 14.3
      },
      {
        no: "33.",
        title: "Beefsteaks",
        description: "4 Stück mit Reis und kleinem Krautsalat",
        price: 16.3
      },
      {
        no: "35.",
        title: "Leber",
        description: "mit Reis und Krautsalat",
        price: 13.5
      },
      {
        no: "37.",
        title: "Steaks",
        description: "2 Stück mit Reis und Krautsalat",
        price: 15.4
      },
      {
        no: "38.",
        title: "Schweinefilet",
        description: "mit Reis und Krautsalat",
        price: 18.3
      },
      {
        no: "39.",
        title: "Schnitzel",
        description: "5 Stück mit Reis und Krautsalat",
        price: 16.9
      },
      {
        no: "30",
        title: "Paniertes Schnitzel",
        price: 14.9,
        description: "mit Pommes frites und grünem Salat"
      },
      {
        no: "40.",
        title: "Schweinekotelett",
        description: "mit Reis und Krautsalat",
        price: 15.9
      },
      {
        no: "41.",
        title: "Bifteki",
        description: "gefüllt mit Fetakäse, Reis und kleinem Bauernsalat",
        price: 17.5
      },
      {
        no: "104.",
        title: "Schweinefilet",
        description: "gefüllt mit Fetakäse, Reis und kleinem Bauernsalat",
        price: 18.6
      },
      {
        no: "133.",
        title: "Herkulesspieß",
        price: 18.5,
        description:
          "1 großer Spieß vom Schwein mit Käse überbacken, dazu Reis und ein kleiner Bauernsalat"
      },
      {
        no: "134.",
        title: "Hawaiisteak",
        price: 17.9,
        description:
          "vom Schwein mit Ananas und Käse überbacken, dazu Reis und ein kleiner Bauernsalat"
      },
      {
        no: "63.",
        title: "Hähnchenbrustfilet",
        price: 18.9,
        description: "mit Reis, Metaxa-Rahmsauce und kleinem Bauernsalat"
      },
      {
        no: "64.",
        title: "Rumpsteak",
        price: 26.9,
        description:
          "aus der Pfanne mit Sauce, Kartoffelecken (potato wedges) und kleinem Bauernsalat"
      },
      {
        no: "65.",
        title: "Peffersteak",
        price: 27.4,
        description:
          "aus der Pfanne mit spezieller Sauce, Kartoffelecken (potato wedges) und kleinem Bauernsalat"
      },
      {
        no: "105.",
        title: "Rumpsteak",
        price: 26.5,
        description:
          "gegrillt mit Kräuterbutter Pommes frites und kleinem Bauernsalat"
      },
      {
        no: "36.",
        title: "Lammkoteletts",
        description: "5 Stück mit Reis und kleinem Bauernsalat",
        price: 23.9
      },
      {
        no: "135.",
        title: "Lammfilet",
        description: "mit Reis und kleinem Bauernsalat",
        price: 24.5
      },
      {
        no: "142.",
        title: "Lammplatte",
        price: 25.5,
        description:
          "1 Lammspieß, 2 Lammfilets, 2 Lammkoteletts, Reis und kleinem Bauernsalat"
      }
    ],
    footer: "Alle Gerichte wahlweise mit Pommes frites oder Reis"
  },

  {
    title: "Hauptgerichte",
    entries: [
      {
        no: "42.",
        title: "Dafni-Platte",
        price: 18.3,
        description:
          "1 Beefsteak, Leber, Filet, Souflaki und Giros, mit Reis und Krautsalat"
      },
      {
        no: "46.",
        title: "Poseidon-Platte",
        price: 17.3,
        description: "1 Filet, 1 Steak, Giros, Reis und Krautsalat"
      },
      {
        no: "47.",
        title: "Artemis-Platte",
        price: 17.3,
        description: "1 Souflaki, Giros, Reis und Krautsalat"
      },
      {
        no: "48.",
        title: "Bacchus-Platte",
        price: 18.9,
        description: "2 Beefsteaks, 1 Filet, 2 Schnitzel, Reis und Krautsalat"
      },
      {
        no: "50.",
        title: "Lukullus-Platte",
        price: 17.9,
        description: "1 Beefsteak, 1 Souflaki, Giros, Reis und Krautsalat"
      },
      {
        no: "51.",
        title: "Trikala-Platte",
        price: 18.2,
        description: "1 Kotelett, 2 Stück Leber, 1 Filet, Reis und Krautsalat"
      },
      {
        no: "52.",
        title: "Olympia-Platte",
        price: 17.9,
        description: "1 Souflaki, 2 Stück Leber, Giros, Reis und Krautsalat"
      },
      {
        no: "53.",
        title: "Karitas-Platte",
        price: 16.2,
        description: "3 Stück Leber, Giros, Reis und Krautsalat"
      },
      {
        no: "54.",
        title: "Apollon-Platte",
        price: 17.2,
        description: "2 Beefsteaks, Giros, Reis und Krautsalat"
      },
      {
        no: "55.",
        title: "Herakles-Platte",
        price: 18.4,
        description: "1 Beefsteak, 2 Filets, Souflaki, Reis und Krautsalat"
      },
      {
        no: "56.",
        title: "Oichalia-Platte",
        price: 19.9,
        description:
          "2 Lammfilets, 2 Schweinefilets mit Reis und kleinem Bauernsalat"
      },
      {
        no: "57.",
        title: "Ouzo-Platte",
        price: 18.9,
        description:
          "2 Stück Leber, 2 Beefsteaks, 2 Schnitzel, Reis und kleinem Bauernsalat"
      },
      {
        no: "58.",
        title: "Athen-Platte",
        price: 17.4,
        description:
          "1 Beefsteak, 3 Stück Leber, 1 Souflaki, Reis und Krautsalat"
      },
      {
        no: "59.",
        title: "Spezial-Platte",
        price: 19.9,
        description:
          "1 Schweinekotelett, 1 Lammkotelett, 2 Stück Leber, 1 Souflaki, Reis und kleinem Bauernsalat"
      },
      {
        no: "60.",
        title: "Dorf-Teller",
        price: 18.9,
        description:
          "1 Souflaki, 1 Steak, Giros, Zaziki, Reis und kleinem Bauernsalat"
      },
      {
        no: "61.",
        title: "Delphi-Platte",
        description: "2 Souflaki und Giros, mit Zaziki, Reis und Krautsalat",
        price: 18.9
      },
      {
        no: "62.",
        title: "Irodio-Platte",
        description:
          "2 Lammkoteletts, 1 Souflaki, Giros, Reis und kleinem Bauernsalat",
        price: 19.3
      }
    ],
    footer: "Alle Gerichte wahlweise mit Pommes frites oder Reis"
  },

  {
    title: "Pfannengerichte",
    entries: [
      {
        no: "137.",
        title: "Beefsteaks",
        price: 16.9,
        description:
          "3 Stück mit Käse, Metaxa-Rahmsauce, Kartoffelecken (potato wedges) und kleinem Bauernsalat"
      },
      {
        no: "139.",
        title: "Giros-Pfanne",
        price: 17.9,
        description:
          "Giros in Metaxa-Rahmsauce mit Käse, Kartoffelecken (potato wedges) und kleinem Bauernsalat"
      },
      {
        no: "141.",
        title: "Kos-Pfanne",
        price: 18.7,
        description:
          "4 Schnitzel mit Metaxa-Rahmsauce mit Käse, Kartoffelecken (potato wedges) und kleinem Bauernsalat"
      }
    ]
  },
  {
    title: "Gerichte für zwei Personen",
    entries: [
      {
        no: "43.",
        title: "Zorbas-Platte",
        price: 41.9,
        description:
          "2 Schweinekoteletts, 2 Filets, 2 Schnitzel, 2 Beefsteaks, Reis und Bauernsalat"
      },
      {
        no: "144.",
        title: "Santorini-Platte",
        price: 45.6,
        description:
          "Giros, 2 Souflaki, 2 Beefsteaks, 4 Lammkoteletts, Reis und Bauernsalat"
      },
      {
        no: "145.",
        title: "Platamonas-Platte",
        price: 42.2,
        description:
          "Giros, 2 Souflaki, 2 Stück Leber, 2 Schnitzel, 2 Filets, Reis und Bauernsalat"
      },
      {
        no: "146.",
        title: "Lammfleisch",
        price: 43.7,
        description:
          "mit griechischen Nudeln, Okra, Auberginen, Spaghetti mit Käse überbacken, Bauernsalat"
      }
    ]
  },

  {
    title: "Gerichte für vier Personen",
    entries: [
      {
        no: "44.",
        title: "Odysseus-Platte",
        price: 78.9,
        description:
          "4 Schweinekoteletts, 4 Filets, 4 Beefsteaks, Giros, Reis und Bauernsalat"
      },
      {
        no: "147.",
        title: "Platon-Platte",
        price: 77.9,
        description:
          "Giros, 4 Souflaki, 4 Beefsteaks, 4 Stück Leber, 4 Filets, Reis und Bauernsalat"
      }
    ],
    footer: "Alle Gerichte wahlweise mit Pommes frites oder Reis"
  },

  {
    title: "Delikatessen aus dem Meer",
    entries: [
      {
        no: "66.",
        title: "Kalamaris",
        description: "Tintenfisch mit Kopfsalat",
        price: 18.4
      },
      {
        no: "67.",
        title: "Fisch-Platte",
        price: 19.7,
        description: "für 1 Person. 1 Fischlachs mit Kalamaris und Kopfsalat"
      },
      {
        no: "68.",
        title: "Fisch-Platte",
        price: 44.9,
        description:
          "für 2 Personen. 2 Seezungenfilets, 4 Scampis und Kalamaris mit Kopfsalat"
      },
      {
        no: "68.b",
        title: "Fischlachs",
        description: "mit Butterreis und Kopfsalat",
        price: 19.1
      },
      {
        no: "69.",
        title: "Scampis",
        description: "6 Stück mit Kopfsalat",
        price: 29.1
      },
      {
        no: "71.",
        title: "Seezungenfilet",
        description: "mit Kalamaris und Kopfsalat",
        price: 19.9
      }
    ]
  },
  {
    title: "Gerichte aus dem Backofen",
    entries: [
      {
        no: "72.",
        title: "Lammfleisch",
        description: "mit Auberginen",
        price: 18.4
      },
      { no: "73.", title: "Lammfleisch", description: "mit Okra", price: 18.4 },
      {
        no: "74.",
        title: "Lammfleisch",
        description: "mit grünen Bohnen",
        price: 18.4
      },
      {
        no: "75.",
        title: "Lammfleisch",
        description: "mit dicken Bohnen",
        price: 18.4
      },
      {
        no: "76.",
        title: "Lammfleisch",
        description: "mit Spaghetti",
        price: 18.4
      },
      {
        no: "77.",
        title: "Lammfleisch",
        description: "mit griechischen Nudeln",
        price: 18.4
      },
      {
        no: "87.",
        title: "Lammfleisch Stifado",
        description: "(Zwiebeln)",
        price: 18.4
      },
      {
        no: "103.",
        title: "Vegetarisch: Gemüse-Auflauf",
        price: 14.4,
        description:
          "mit Erbsen, Karotten, Broccoli und Blumenkohl, mit Käse überbacken und Tomatensauce"
      },
      {
        no: "78.",
        title: "Spaghetti",
        description: "mit Hackfleisch",
        price: 13.1
      },
      {
        no: "79.",
        title: "Spaghetti",
        description: "mit Tomatensauce",
        price: 10.9
      },
      {
        no: "80.",
        title: "Moussakas",
        price: 18.4,
        description:
          "Auberginenauflauf mit Hackfleisch, Kartoffeln und Bechamelsauce"
      }
    ]
  },

  {
    title: "Nachspeisen",
    entries: [
      {
        no: "89.",
        title: "Galaktoburiko",
        description: "gefüllter Eiercremeblätterteig mit Vanilleeis",
        price: 7.8
      },
      { no: "99.", title: "Gemischtes Eis", price: 5.9 },
      {
        no: "161.",
        title: "Vanille-Eis",
        description: "mit Schokosauce",
        price: 6.2
      },
      {
        no: "162.",
        title: "Vanille-Eis",
        description: "mit Erdbeersauce",
        price: 6.4
      },
      {
        no: "163.",
        title: "Vanille-Eis",
        description: "mit Caramelsauce",
        price: 6.4
      },
      { no: "164.", title: "Bananensplit", price: 7.9 },
      { no: "165.", title: "Dafni-Eiscreme", price: 8.1 }
    ],
    footer: "1 Portion Sahne + 1,50 €"
  }
];

const drinks = [
  {
    title: "Weine Karaffe",
    entries: [
      { title: "Roditis, rosé (herb) ", quantity: "0,25 l", price: 6.0 },
      { title: "Kokineli, rot (herb) ", quantity: "0,25 l", price: 6.0 },
      { title: "Naousa, rot (herb) ", quantity: "0,25 l", price: 6.0 },
      { title: "Demestica, rot (herb) ", quantity: "0,25 l", price: 6.0 },
      { title: "Demestica, weiß (herb)", quantity: "0,25 l", price: 6.0 },
      { title: "Retsina, weiß (geharzt) ", quantity: "0,25 l", price: 6.0 },
      { title: "Imigliko, rot (halbsüß) ", quantity: "0,25 l", price: 6.0 },
      { title: "Imigliko, weiß (halbsüß) ", quantity: "0,25 l", price: 6.0 },
      { title: "Rhodos, rot (halbtrocken) ", quantity: "0,25 l", price: 6.0 },
      { title: "Mavrodaphni, rot (sehr süß) ", quantity: "0,25 l", price: 6.6 },
      { title: "Samos (süß) ", quantity: "0,25 l", price: 6.6 },
      {
        title: "Apelia Black Label (lieblich) ",
        quantity: "0,25 l",
        price: 6.6
      }
    ]
  },
  {
    title: "Weine Flasche",
    entries: [
      { title: "Roditis, rosé (herb) ", quantity: "0,7 l", price: 19.5 },
      { title: "Kokineli, rot (herb) ", quantity: "0,7 l", price: 19.5 },
      { title: "Naousa, rot (herb) ", quantity: "0,7 l", price: 21.0 },
      { title: "Demestica, rot (herb) ", quantity: "0,7 l", price: 19.5 },
      { title: "Demestica, weiß (herb) ", quantity: "0,7 l", price: 19.5 },
      {
        title: "Kouros, weiß oder rot (trocken) ",
        quantity: "0,7 l",
        price: 24.0
      },
      {
        title: "Rosé Boutari fruchtiges Aroma (halb süß) ",
        quantity: "0,7 l",
        price: 21.0
      },
      {
        title: "Apelia Black Label (lieblich) ",
        quantity: "0,7 l",
        price: 22.0
      },
      { title: "Imigliko, rot (halbsüß) ", quantity: "0,7 l", price: 19.5 },
      { title: "Rhodos, rot (halbtrocken) ", quantity: "0,7 l", price: 21.0 },
      { title: "Mavrodaphni, rot (süß) ", quantity: "0,7 l", price: 23.5 },
      { title: "Samos, weiß (süß) ", quantity: "0,7 l", price: 23.5 },
      { title: "Retsina, weiß (geharzt) ", quantity: "0,7 l", price: 20.5 },
      {
        title: "Santorini, weiß Qualitätswein (trocken) ",
        quantity: "0,7 l",
        price: 24.9
      },
      {
        title: "Agioritiko, weiß Qualitätswein aus Chalkidiki (trocken) ",
        quantity: "0,7 l",
        price: 24.5
      },
      {
        title: "Malamatina, weiß Retsina (geharzt) ",
        quantity: "0,7 l",
        price: 19.0
      },
      {
        title: "Rubig Calliga, rot Qualitätswein (tocken) ",
        quantity: "0,7 l",
        price: 25.0
      },
      { title: "Imigliko, weiß (halbsüß) ", quantity: "0,7 l", price: 19.5 },
      {
        title: "Agiorgitiko, rot Qualitätswein (trocken) ",
        quantity: "0,7 l",
        price: 25.0
      }
    ]
  },
  {
    title: "Heiße Getränke",
    entries: [
      { title: "Mocca nach griechischer Art", price: 2.7 },
      { title: "Tasse Tee", price: 2.6 },
      { title: "Tasse Kaffee", price: 2.6 },
      { title: "Glühwein ", price: 4.0 },
      { title: "Cappuccino ", price: 3.2 },
      { title: "Latte Macchiato ", price: 3.5 },
      { title: "Espresso", price: 2.7 }
    ]
  },
  {
    title: "Spirituosen",
    entries: [
      { title: "Ouzo", quantity: "2 cl", price: 2.8 },
      { title: "Korn", quantity: "2 cl", price: 2.7 },
      { title: "Bananen-Likör", quantity: "2 cl", price: 2.8 },
      { title: "Underberg", quantity: "2 cl", price: 2.9 },
      { title: "Fernet Branca", quantity: "2 cl", price: 3 },
      { title: "Fernet Branca menthol", quantity: "2 cl", price: 3 },
      { title: "Jägermeister", quantity: "2 cl", price: 3.2 },
      { title: "Amanda", quantity: "2 cl", price: 3.0 },
      { title: "Sherry medium", quantity: "2 cl", price: 3.5 },
      { title: "Sherry dry", quantity: "2 cl", price: 3.5 },
      { title: "Metaxa 5 Sterne", quantity: "2 cl", price: 4.9 },
      { title: "Metaxa 7 Sterne", quantity: "2 cl", price: 5.5 },
      { title: "Metaxa flambiert", quantity: "2 cl", price: 6.0 },
      { title: "Jonny Walker Whisky ", quantity: "2 cl", price: 5.0 },
      { title: "Jim Beam Whisky ", quantity: "2 cl", price: 5.1 },
      { title: "Bacardi Cola ", quantity: "5 cl", price: 5.5 },
      { title: "Wodka", quantity: "2 cl", price: 4.9 },
      { title: "Charly ", quantity: "5 cl", price: 5.2 },
      { title: "Campari ", quantity: "2 cl", price: 5.2 },
      { title: "Martini rot ", quantity: "5 cl", price: 5.2 },
      { title: "Martini weiß", quantity: "5 cl", price: 5.2 },
      { title: "Sekt", quantity: "5 cl", price: 4.9 }
    ]
  },
  {
    title: "Erfrischungsgetränke",
    entries: [
      { title: "Seven Up", quantity: "0,3 l", price: 3.5 },
      { title: "Pepsi ", quantity: "0,3 l", price: 3.5 },
      { title: "Pepsi light ", quantity: "0,3 l", price: 3.5 },
      { title: "Orangenlimonade", quantity: "0,3 l", price: 3.5 },
      { title: "Bitter Lemon ", quantity: "0,3 l", price: 3.7 },
      { title: "Ginger Ale ", quantity: "0,3 l", price: 3.7 },
      { title: "Orangensaft ", quantity: "0,3 l", price: 3.7 },
      { title: "Mineralwasser", quantity: "0,25 l", price: 2.8 },
      { title: "Apfelsaft ", quantity: "0,3 l", price: 3.6 },
      { title: "Bananensaft", quantity: "0,3 l", price: 3.6 },
      { title: "Kirschsaft", quantity: "0,3 l", price: 3.6 },
      { title: "Spezi ", quantity: "0,3 l", price: 3.5 },
      { title: "Apfelschorle", quantity: "0,3 l", price: 3.6 }
    ]
  },
  {
    title: "Biere",
    entries: [
      { title: "vom Faß ", quantity: "0,3 l", price: 3.5 },
      { title: "vom Faß", quantity: "0,4 l", price: 4.0 },
      { title: "alkoholfrei (Flasche)", quantity: "0,33 l", price: 3.7 },
      { title: "Dunkel Bier (Flasche)", quantity: "0,33 l", price: 3.7 },
      { title: "Vita Malz (Flasche)", quantity: "0,33 l", price: 3.7 },
      {
        title: "Warsteiner Radler alkoholfrei (Flasche)",
        quantity: "0,33 l",
        price: 3.7
      },
      {
        title: "König Ludwig Weissbier dunkel (Flasche)",
        quantity: "0,5 l",
        price: 4.8
      },
      {
        title: "Weizenbier alkoholfrei (Flasche)",
        quantity: "0,5 l",
        price: 4.8
      },
      {
        title: "König Ludwig Weissbier vom Fass",
        quantity: "0,5 l",
        price: 4.9
      }
    ],
    footer: "Alle Preise verstehen sich einschließlich Service und Mehrwertsteuer!"
  }
];

// Mittagskarte
const lunchDishes = [
  {
    title: "",
    info: "Alle Gerichte wahlweise mit Pommes frites.",
    entries: [
      {
        no: "700.",
        title: "Giros",
        description: "mit Reis und Krautsalat",
        price: 8.9
      },
      {
        no: "701.",
        title: "Diogenes",
        description: "Giros, 1 Souflaki mit Reis und Krautsalat",
        price: 11.5
      },
      {
        no: "702.",
        title: "Hermes",
        description: "Giros, 1 Steak mit Reis und Krautsalat",
        price: 11.7
      },
      {
        no: "703.",
        title: "Zeus",
        description: "Giros, 2 Stück Leber mit Reis und Krautsalat",
        price: 10.9
      },
      {
        no: "704.",
        title: "Souzoukia",
        description: "3 Stück, mit Reis und Krautsalat",
        price: 10.9
      },
      {
        no: "705.",
        title: "Souflaki",
        description: "1 Stück, mit Reis und Krautsalat",
        price: 9.5
      },
      {
        no: "708.",
        title: "Leber",
        description: "3 Stück, mit Reis und Krautsalat",
        price: 8.5
      },
      {
        no: "709.",
        title: "Steak",
        description: "1 Stück, mit Reis und Krautsalat",
        price: 9.9
      },
      {
        no: "710.",
        title: "Hähnchenbrustfilet",
        description: "mit Metaxa-Rahmsauce, Reis und Krautsalat",
        price: 10.9
      },
      {
        no: "711.",
        title: "Bifteki",
        description:
          "gefüllt mit Käse, dazu Reis und Krautsalat",
        price: 10.9
      }
    ]
  },
  {
    title: "Fisch",
    entries: [
      {
        no: "712.",
        title: "Seezungenfilet und Kalamares",
        description:
          "1 Stück Seezungenfilet und Kalamares, mit Knoblauch-Sauce und grünem Salat",
        price: 15.5
      },
      {
        no: "715.",
        title: "Kalamares",
        description: "mit Knoblauchsauce und grünem Salat",
        price: 12.5
      }
    ]
  },
  {
    title: "Aus dem Backofen",
    entries: [
      {
        no: "716.",
        title: "Spaghetti",
        description: "mit Tomatensauce",
        price: 8.5
      },
      {
        no: "717.",
        title: "Spaghetti",
        description: "mit Hackfleischsauce",
        price: 9.5
      }
    ]
  }
];

export default {
  dishes,
  drinks,
  lunchDishes
};

/*
// gerichte / dishes
#(.*)
{\n  title:"\1",\n  entries: [
^(\d*\.\w?) ([^\.]*)(\. )*(.*)$
{ no:"\1", title:"\2", price: \4 },
 \},\n(\w.*)
, description:"\1" }\n
},\n\n{
},\n  ]\n{
price: (\d.*)(\,)(\d{1,2})
price: \1.\3
// getränke / drinks
#(.*)
{\n  title:"\1",\n  entries: [
\n\n{
\n  ]\n},\n{
//inline intention
^(\w)
    \1
( {4})([^\.]*)(. )*(\d.*)
    { title: "\2", price: "\4" },
price: "(\d,?\d{0,2} c?l)
quantity: "\1", price: "
price: "(\d{1,2}),(\d{1,2})"
price: \1\.\2
*/
